<template>
<div class="chapter">
<div class="inner_page">
<p class="copy1">Publisher: Amy Marson</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Project Editor: Alice Mace Nakanishi</p>
<p class="copy">Compiler: Lindsay Conner</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Page Layout Artist: Casey Dukes</p>
<p class="copy">Production Coordinator: Joe Edge</p>
<p class="copy">Photography by Nissa Brehmer, Christina Carty-Francis, and Diane Pedersen of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copy">For further information and similar projects, see the book listed after each artist’s bio.</p>
<p class="copy">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?2c63ad0d